import styled from '@emotion/styled';
import { colors } from '../../global';
import { media } from '../../services/media';

export const BubbleText = styled.div`
    text-align: center;

    h3 {
        font-weight: 400;
        font-size: 26px;
        line-height: 0.93;
        display: flex;
        margin: 0 0 38px;
        text-align: left;

        ${media.min('lg')} {
            font-size: 2.17vw;
            margin-bottom: 3vw;
        }

        ${media.min('xxl')} {
            font-size: 50px;
            margin-bottom: 60px;
        }

        span {
            font-size: 60px;
            line-height: 0.8;
            margin-right: 3px;

            ${media.min('lg')} {
                font-size: 5vw;
            }
            ${media.min('xxl')} {
                font-size: 114px;
            }
        }
    }

    button {
        color: ${colors.white};
        font-size: 22px;

        ${media.min('lg')} {
            font-size: 2.22vw;
        }

        ${media.min('xxl')} {
            font-size: 35px;
        }
    }
`;
